import React from 'react'
import { FormattedMessage, defineMessages } from 'react-intl'

export const SEARCH_CONTROL_EMPTY = (
    <FormattedMessage id="clan_landing.search_control.empty" defaultMessage="Введите название или тег клана" />
)

export const SEARCH_CONTROL_SINGLE_LETTER = (
    <FormattedMessage
        id="clan_landing.search_control.single_letter"
        defaultMessage="Введите не менее 2 символов для поиска клана"
    />
)

export const SEARCH_CONTROL_ENTER = (
    <FormattedMessage id="clan_landing.search_control.enter" defaultMessage="Нажмите Еnter для поиска клана" />
)

export const SEARCH_CONTROL = defineMessages({
    placeholder: {
        id: 'clan_landing.search_control.placeholder',
        defaultMessage: 'Поиск клана',
    },
})



// WEBPACK FOOTER //
// ./containers/Landing/components/LandingClans/components/SearchControl/translations.jsx